import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BellOff, Loader2 } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { newsApi } from "@/components/news/newsUtils";

export default function ReminderCancel() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [state, setState] = useState("idle");
  const cancel = async () => {
    setState("loading");
    try { await newsApi.post("/reminders/cancel", { token }); setState("done"); } catch { setState("error"); }
  };
  return (
    <section className="min-h-[80svh] bg-navy pb-24 pt-40 text-paper" data-testid="reminder-cancel-page">
      <Seo title="Cancel Event Reminder | First Responders Foundation" description="Cancel an event reminder email." path="/news/reminder-cancel" noindex />
      <div className="container-x">
        <div className="max-w-xl">
          <BellOff className="text-gold" size={30} aria-hidden="true" />
          <h1 className="mt-6 text-3xl font-extrabold text-paper">Cancel Event Reminder</h1>
          <div className="mt-8 bg-paper p-6 text-ink md:p-8">
            {state === "done" ? (
              <p className="text-sm text-navy" data-testid="reminder-cancel-done">Your reminder is cancelled. You won't get any more emails about this event.</p>
            ) : !token ? (
              <p className="text-sm text-fire" data-testid="reminder-cancel-invalid">This link is incomplete.</p>
            ) : (
              <>
                <p className="text-sm text-ink">Click below and we won't send you a reminder for this event.</p>
                {state === "error" && <p className="mt-3 text-sm text-fire" role="alert" data-testid="reminder-cancel-error">This link is not valid.</p>}
                <button type="button" onClick={cancel} disabled={state === "loading"} className="btn btn-navy mt-6 w-full disabled:opacity-60" data-testid="reminder-cancel-button">
                  {state === "loading" && <Loader2 size={16} className="animate-spin" />} Cancel My Reminder
                </button>
              </>
            )}
            <Link to="/news" className="mt-6 inline-block text-sm font-semibold text-navy underline underline-offset-4" data-testid="reminder-cancel-news-link">Back to News & Events</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
